export default __webpack_public_path__ + "static/media/map-image.3cd6dd98.png";